/**
 * P0 Clinic Dashboard API
 * Endpoints for clinic overview, today's appointments, and statistics
 */
import axiosInstance from './axiosInstance';

const BASE = '/dashboard/clinic/';

export const dashboardApi = {
  /**
   * Get clinic overview with today's appointments and stats
   * @returns {Promise} Overview data including appointments, stats, recent activity
   */
  getOverview: () => 
    axiosInstance.get(`${BASE}overview/`).then((r) => r.data),

  /**
   * Get detailed list of today's appointments
   * @returns {Promise} Today's appointments with patient and doctor details
   */
  getTodayAppointments: () => 
    axiosInstance.get(`${BASE}today_appointments/`).then((r) => r.data),

  /**
   * Get comprehensive clinic statistics
   * @returns {Promise} Monthly stats, doctor count, patient count
   */
  getStats: () => 
    axiosInstance.get(`${BASE}stats/`).then((r) => r.data),
};

export default dashboardApi;

